import React from "react";
import { alpha, Box, Button, Container, Link, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { ClientHelmet } from "../components/common/ClientHelmet";
import { FONT_MONO } from "../theme";

export const NotFound: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: "65vh",
        display: "flex",
        alignItems: "center",
        py: { xs: 8, md: 10 },
      }}
    >
      <ClientHelmet>
        <title>Page Not Found | Obsidian Ridge AI</title>
        <meta name="robots" content="noindex, nofollow" />
      </ClientHelmet>
      <Container maxWidth="lg">
        {/* Oversized mono status code: low-emphasis display element, the
            one place large mono is the point rather than a metadata voice. */}
        <Typography
          component="p"
          sx={{
            fontFamily: FONT_MONO,
            fontWeight: 500,
            fontSize: { xs: "5rem", md: "7rem" },
            lineHeight: 1,
            letterSpacing: "-0.02em",
            fontVariantNumeric: "tabular-nums",
            color: (t) => alpha(t.palette.text.secondary, 0.55),
            mb: 2,
          }}
        >
          404
        </Typography>
        <Typography variant="h2" component="h1" gutterBottom>
          We couldn't find that page
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: "62ch", mb: 4 }}>
          It may have moved or never existed. The Signal Desk, the resource guides, and the blog are
          all still where they should be.
        </Typography>
        <Stack direction="row" spacing={3} useFlexGap flexWrap="wrap" alignItems="center">
          <Button variant="contained" component={RouterLink} to="/">
            Home
          </Button>
          <Link
            component={RouterLink}
            to="/signal"
            underline="hover"
            sx={{ color: "text.secondary", "&:hover": { color: "text.primary" } }}
          >
            Signal Desk
          </Link>
          <Link
            component={RouterLink}
            to="/resources"
            underline="hover"
            sx={{ color: "text.secondary", "&:hover": { color: "text.primary" } }}
          >
            Resource guides
          </Link>
          <Link
            component={RouterLink}
            to="/blog"
            underline="hover"
            sx={{ color: "text.secondary", "&:hover": { color: "text.primary" } }}
          >
            Blog
          </Link>
        </Stack>
      </Container>
    </Box>
  );
};
